module.exports = __webpack_public_path__ + "img/pdf_noir.fe955e66.png";